import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import GameImage from '../components/GameImage';

const HomePage = ({ gameData }) => {
  const [categories, setCategories] = useState([]);
  const [featuredGames, setFeaturedGames] = useState([]);
  
  useEffect(() => {
    if (gameData) {
      // Extract categories from the data
      const categoryNames = Object.keys(gameData);
      setCategories(categoryNames);
      
      // Get featured games (first few games from each category)
      const featured = [];
      categoryNames.forEach(category => {
        if (gameData[category] && gameData[category].length > 0) {
          const topGames = gameData[category].slice(0, 2);
          topGames.forEach(game => {
            featured.push({
              ...game,
              category
            });
          });
        }
      });
      setFeaturedGames(featured.slice(0, 6));
    }
  }, [gameData]);

  return (
    <HomeContainer>

      {/* Popular Games Section */}
      <GameSection>
        <SectionHeader>
          <SectionTitle>Popular Games</SectionTitle>
          <ViewMoreLink to="/popular">View more &gt;</ViewMoreLink>
        </SectionHeader>
        <GameGrid>
          {featuredGames.map(game => (
            <GameCard key={`${game.category}-${game.id}`}>
              <Link to={`/game/${game.category}/${game.id}`}>
                <GameImage 
                  src={game.thumb300x300} 
                  fallbackSrc={game.thumb512x384} 
                  alt={game.name} 
                  style={{ width: '100%', height: 'auto', display: 'block' }} 
                />
              </Link>
            </GameCard>
          ))}
        </GameGrid>
      </GameSection>

      {/* Categories Section */}
      {categories.map(category => (
        <GameSection key={category}>
          <SectionHeader>
            <SectionTitle>{category.charAt(0).toUpperCase() + category.slice(1)} Games</SectionTitle>
            <ViewMoreLink to={`/category/${category}`}>View more &gt;</ViewMoreLink>
          </SectionHeader>
          <GameGrid>
            {gameData[category].slice(0, 8).map(game => (
              <GameCard key={game.id}>
                <Link to={`/game/${category}/${game.id}`}>
                  <GameImage 
                    src={game.thumb300x300} 
                    fallbackSrc={game.thumb512x384} 
                    alt={game.name} 
                    style={{ width: '100%', height: 'auto', display: 'block' }} 
                  />
                </Link>
              </GameCard>
            ))}
          </GameGrid>
        </GameSection>
      ))}
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  padding: 10px 0;
`;

const GameSection = styled.section`
  margin-bottom: 15px;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  margin: 0;
`;

const ViewMoreLink = styled(Link)`
  color: #45b7d8;
  text-decoration: none;
  font-size: 14px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const GameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 5px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(6, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const GameCard = styled.div`
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

// GameThumbnail is now replaced by the GameImage component with inline styles

export default HomePage;
